import React, {Fragment} from 'react'
import moment from 'moment'
import {SectionBox} from 'common/styleguide/SectionBox'
import {CTA} from 'common/styleguide/CTA'
import {DisableDialog} from './DisableDialog'
import {PublishDialog} from './PublishDialog'
import {PreviewModal} from './PreviewModal'
import {connect} from 'react-redux'
import {CircleSpinner} from 'common/spinners/CircleSpinner'
import {experienceActions} from 'data/resources/experiences'
import {ShareModal} from '../ShareModal'

export class _Publish extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      showDisableDialog: false,
      showPublishDialog: false,
      publishPending: false,
      showShareDialog: false
    }
  }

  componentDidMount () {
    this.pollIfPublishing()
  }

  componentDidUpdate () {
    this.pollIfPublishing()
  }

  pollIfPublishing () {
    const {lastPackage} = this.props
    if (lastPackage && !lastPackage.packageFileSize) {
      if (!this._loadLastPackageTimer) {
        this._loadLastPackageTimer = window.setTimeout(() => {
          delete this._loadLastPackageTimer
          this.props.loadLastPackage()
        }, 1000)
      }
      this.setState({publishPending: true})
    } else {
      this.setState({publishPending: false})
    }
  }

  publish = () => {
    this.setState({publishPending: true})
    this.props.publish().then(() => {
      this.setState({
        showPublishDialog: true
      })
    })
  }

  render () {
    const {disable, experience, lastPackage, hasUpdates} = this.props
    const {showDisableDialog, showPublishDialog, showShareDialog, showPreview, publishPending} = this.state
    const disabled = !experience.active
    const canPublish = (!publishPending && hasUpdates) || disabled

    return (
      <Fragment>
        <SectionBox title='Publish' noPadding>
          <div style={{padding: '20px 20px 0 20px'}}>
            {!publishPending && <p>Publish the Experience to make your content available to guests.</p>}
            {publishPending && <p>The experience package is being built. This can take several minutes.</p>}
            <CTA
              onClick={canPublish ? this.publish : null}
              disabled={!canPublish}>
              {publishPending && <Fragment>
                <CircleSpinner size={14} /><span style={{ marginLeft: '10px' }}>Publishing...</span>
              </Fragment>}
              {!publishPending && canPublish && <Fragment>Publish{lastPackage && !disabled && ' Updates'}</Fragment>}
              {!publishPending && !canPublish && <Fragment>Published {moment(lastPackage.createdAt).format('YYYY-MM-DD')}</Fragment>}
            </CTA>
            {lastPackage && !disabled && <CTA secondary onClick={() => this.setState({showDisableDialog: true})}>Unpublish</CTA>}
            <CTA secondary onClick={() => this.setState({showPreview: true})}>Preview</CTA>
          </div>
        </SectionBox>
        {showDisableDialog && <DisableDialog
          closeDialog={() => this.setState({showDisableDialog: false})}
          disable={disable}
          experience={experience} />}
        {showPublishDialog && <PublishDialog
          publishPending={publishPending}
          closeDialog={() => this.setState({showPublishDialog: false})}
          shareAccessCode={() => this.setState({showPublishDialog: false, showShareDialog: true})}
          experience={experience} />}
        {showShareDialog && <ShareModal
          onRequestClose={() => this.setState({showShareDialog: false})}
          experience={experience} />}
        {showPreview && <PreviewModal
          onRequestClose={() => this.setState({showPreview: false})}
          experience={experience} />}
      </Fragment>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {id} = ownProps.experience
  return {
    publish: () => dispatch(experienceActions.publish(id)),
    disable: () => dispatch(experienceActions.disable(id)),
    loadLastPackage: () => dispatch(experienceActions.lastPackage(id))
  }
}

export const Publish = connect(
  null,
  mapDispatchToProps
)(_Publish)
